<ng-container>
  <nz-time-picker
    nz-col
    nzSpan="24"
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    [disabled]="disabled"
    [nzDisabled]="disabled"
    nzFormat="HH:mm"
    style="width: 100%"
  ></nz-time-picker>
</ng-container>
